module.exports = __webpack_public_path__ + "e6d3f5b51189645a48065589d0a886f6.png";